import { gql } from '__generated__';

export default gql(`
  mutation GenerateCouponCodes($input: GenerateCouponCodesInput!) {
    generateCouponCodes(input: $input) {
      ...CouponFields
    }
  }
`);
